<template>
  <div class="sign-container">
    <div class="sign-frame">
      <div class="sign-side blue">
        <img :src="this.baseURL + '/mascots/main.svg'" alt="DS Mascot" />
        <h1 v-html="$t('SignupWizard.welcome')"></h1>

        <h3 v-html="$t('make_planning')"></h3>

        <div class="quote">
          <p v-html="$t('SignupWizard.quote')"></p>
        </div>
      </div>

      <div class="sign-side">
        <div class="form">
          <h2 class="mb-5">{{ $t("SignupWizard.set_password") }}</h2>

          <div class="field">
            <label class="required-label" for="password">{{ $t("SignupWizard.password") }}</label>
            <InputText
              id="password"
              :placeholder="$t('SignupWizard.minimum_password')"
              type="password"
              v-model="password"
            />
          </div>

          <Button
            :disabled="!isValid || busy"
            class="btn-submit"
            @click="signUp"
            :label="$t('SignupWizard.create_password')"
          />
          <div v-if="!jpLocale">
            <div class="or-divider mt-2 mb-1">Or</div>

            <div class="button se-button" @click="startSportsEngineAuth">
              Sign up with
              <img src="/se_logo_full.png" alt="Sports Engine" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    link: [{ rel: "canonical", href: "https://app.cactusware.com/sign-up/wizard" }],
  },
  data() {
    return {
      busy: false,
      email: "",
      password: "",
      search: window.location.search,
    };
  },
  computed: {
    isValid() {
      return this.validateEmail(this.email) && this.password.length > 6;
    },
  },
  methods: {
    signUp() {
      this.busy = true;
      const user = {
        email: this.email.toLowerCase(),
        first: this.email.split("@")[0],
        password: this.password,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timezone_offset: this.$moment(new Date()).format("Z"),
        locale: this.$i18n.locale,
      };
      api
        .updateUser(user)
        .then(() => {
          this.$store
            .dispatch("signIn", {
              email: this.email.toLowerCase(),
              password: this.password,
            })
            .then(() => {
              window.analytics.identify(this.currentUser.id, {
                name: user.first,
                email: user.email,
              });
              localStorage.setItem("user_id", user.id);
              localStorage.setItem("user_email", user.email);
              localStorage.setItem("locale", user.locale);
              this.trackEvent("Signed In", { user: user });
              this.$store.dispatch("getLeagueInformation");

              this.makeToast("success", this.$t("SignupWizard.password_created"));

              if (this.$store.getters.currentLeague) {
                this.goRouter("/");
              } else {
                this.goRouter("/wizard");
              }
            });
        })
        .catch(error => console.error(error));
    },
  },
  mounted() {
    window.analytics.page();

    if (this.currentUser) {
      this.email = this.currentUser.email;
    }
  },
};
</script>
